<template>
  <v-card>
    <v-toolbar dark color="secondary">
      <v-toolbar-title>{{ title }}</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <!-- Chart -->
      <apexchart
        v-if="loaded"
        type="pie"
        width="100%"
        height="400"
        :options="chartOptions"
        :series="series"
      ></apexchart>
      <v-skeleton-loader
        v-else
        class="mx-auto"
        type="image"
      ></v-skeleton-loader>
    </v-card-text>
  </v-card>
</template>

<script>
import axios from "@/plugins/axios";
export default {
  props: {
    title: {
      type: String,
      default: "Ticket Spread",
    },
    endpoint: {
      type: String,
    },
    agents: {
      type: Array,
    },
  },
  data() {
    return {
      series: [],
      labels: [],
      loaded: false,
      interval: null,
    };
  },
  mounted() {
    this.getData();
    this.interval = setInterval(() => {
      this.getData();
    }, 30000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    getData() {
      axios.get(this.endpoint).then((res) => {
        this.series = [];
        this.labels = [];
        // Split the res.data object {label: 'value', label: 'value'} into series and labels

        for (const [key, value] of Object.entries(res.data)) {
          console.log(key, value);
          this.labels.push(key);
          this.series.push(value);
        }

        console.log(this.series);
        this.loaded = true;
      });
    },
  },
  computed: {
    chartOptions() {
      console.log(this.agents);
      // if agents is not empty find agents first and last name and return it as the label instead

      return {
        labels: this.labels.map((label) => {
          let agent = this.agents.find((agent) => {
            return agent.email === label;
          });
          return agent ? `${agent.first_name} ${agent.last_name}` : label;
        }),
      };
    },
  },
};
</script>
